import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Calendar,
  Mail,
  User,
  LogOut
} from 'lucide-react';

const PatientSidebar = () => {
  const location = useLocation(); // Ottieni il percorso corrente

  // Funzione helper per determinare se un link è attivo
  const isActive = (path) => location.pathname.includes(path);

  return (
    <nav className="mt-6">
      <Link
        to="/patient/dashboard"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/patient/dashboard')
            ? 'bg-orange-100 text-orange-700'
            : 'hover:bg-orange-100 text-gray-700'
          }`}
      >
        <Home className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Bacheca</span>
      </Link>

      <Link
        to="/patient/appointments"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/patient/appointments')
            ? 'bg-orange-100 text-orange-700'
            : 'hover:bg-orange-100 text-gray-700'
          }`}
      >
        <Calendar className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Appuntamenti</span>
      </Link>

      <Link
        to="/patient/messages"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/patient/messages')
            ? 'bg-orange-100 text-orange-700'
            : 'hover:bg-orange-100 text-gray-700'
          }`}
      >
        <Mail className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Messaggi</span>
      </Link>

      <Link
        to="/patient/profile"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/patient/profile')
            ? 'bg-orange-100 text-orange-700'
            : 'hover:bg-orange-100 text-gray-700'
          }`}
      >
        <User className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Profilo</span>
      </Link>

      <Link
        to="/logout"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/logout')
            ? 'bg-orange-100 text-orange-700'
            : 'hover:bg-orange-100 text-gray-700'
          }`}
      >
        <LogOut className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Logout</span>
      </Link>

      {/* Pulsante di assistenza */}
      <div className="h-6"></div>
      <div className="p-4">
        <a
          href="mailto:help@personaltherapy.it"
          className="block bg-purple-600 text-white p-4 rounded-lg shadow-lg hover:bg-purple-700 transition-colors text-center"
        >
          <h3 className="font-bold">Hai bisogno di assistenza?</h3>
          <p className="text-sm">Scrivi subito a help@personaltherapy.it!</p>
        </a>
      </div>

    </nav>
  );
};

export default PatientSidebar;